module.exports = __webpack_public_path__ + "static/TradePenguin-b5361a30dca230a35e6cd49c7fa5f117.gif";